<script setup lang="ts">
import BannerActions from '../components/banner-actions.vue'
import FormBanner from '../components/form-banner.vue'
import { useBannerStore } from '../store/useBannerStore'

definePage({
  meta: {
    navActiveLink: 'banner',
    action: 'edit',
    subject: 'banner',
  },
})

const store = useBannerStore()
const router = useRouter()

const {
  fetchItem,
} = store

const {
  data,
} = storeToRefs(store)

async function handleUpdate() {
  await fetchItem(router.currentRoute.value.params.id as string)
}

fetchItem(router.currentRoute.value.params.id as string)
</script>

<template>
  <VRow>
    <VCol
      cols="12"
      md="8"
    >
      <FormBanner is-editing />
    </VCol>

    <VCol
      cols="12"
      md="4"
    >
      <BannerActions @update="handleUpdate" />
    </VCol>
  </VRow>
</template>
